import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../../../views/ReportView/ReportView.module.css";
import "../../../ReviewComponents/ABMOfDocuments/ABMOfDocuments.css";
import IconAnimation from "../../../iconAnimation/iconAnimation";
import NotReportViewData from "../../../NotReportViewData/NotReportView";
import { HiDocumentCheck } from "react-icons/hi2";
import AMBListFondistaCompany from "../ABMListFondistaCompany/ABMListFondistaCompany";
import AMBListProveedorCompany from "../ABMListProveedorCompany/ABMListProveedorCompany";
import Swal from "sweetalert2";
import axios from "axios";
import { FaArrowRight } from "react-icons/fa";

const ABMOfDocumentsCompanies = ({ data }) => {
  const navigate = useNavigate();
  const [company, setCompany] = useState(data);
  const [file, setFile] = useState(null);
  const [reloadData, setReloadData] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [typeDocument, setTypeDocument] = useState("");
  const [fileId, setFileId] = useState("");
  const [viewList, setViewList] = useState({
    viewList: false,
    tipeForm: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      // Validar que el tamaño del archivo no supere 200 KB
      const maxSizeKB = 5242880; // 3 GB en kilobytes
      const fileSizeKB = selectedFile.size / 1024; // Convertir bytes a kilobytes

      if (fileSizeKB > maxSizeKB) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `El archivo seleccionado supera el tamaño máximo permitido de ${
            maxSizeKB / 1024 / 1024
          } GB.`,
        });
        return; // No continuar con la carga del archivo
      }

      const newFileName = `${typeDocument}_${
        company.id
      }${selectedFile.name.substr(selectedFile.name.lastIndexOf("."))}`;
      const renamedFile = new File([selectedFile], newFileName, {
        type: selectedFile.type,
      });
      const url = URL.createObjectURL(selectedFile);
      setFileUrl(url);
      setFile(renamedFile);

      Swal.fire({
        icon: "success",
        title: "Archivo Cargado",
        text: "El archivo se ha cargado con éxito.",
      });
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    const endpoint = `${process.env.REACT_APP_ABM_OF_DOCUMENT_COMPANY}`;

    try {
      const formData = new FormData();

      // Agrega el archivo al FormData sin decodificarlo
      formData.append("document", file);

      // Quita el prefijo "blob:" de la URL antes de agregarla al FormData
      const cleanedFileUrl = fileUrl.replace(/^blob:/, "");

      // Agrega la URL sin el prefijo "blob:" al FormData
      formData.append("url", cleanedFileUrl);

      // Agrega otros campos de datos al FormData
      formData.append("description", company.description);
      formData.append("typeDocument", typeDocument);
      formData.append("expiresAt", company.expiresAt);
      formData.append("userId", company.id);

      // Realiza la solicitud con el FormData
      const res = await axios.post(endpoint, formData);

      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Se ha creado el documento con éxito." || res.data.message,
      });
      reloadChildData();
      setViewList({ ...viewList, viewList: false });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de enviar el documento.",
      });
    }
  };

  const editamb = async (e) => {
    e.preventDefault();
    const endpoint = `${process.env.REACT_APP_ABM_OF_DOCUMENT_COMPANY_EDIT}${fileId}`;

    try {
      const formData = new FormData();

      // Agrega el archivo al FormData sin decodificarlo
      formData.append("document", file);

      // Quita el prefijo "blob:" de la URL antes de agregarla al FormData
      const cleanedFileUrl = fileUrl.replace(/^blob:/, "");

      // Agrega la URL sin el prefijo "blob:" al FormData
      formData.append("url", cleanedFileUrl);

      // Agrega otros campos de datos al FormData
      formData.append("description", company.description);
      formData.append("typeDocument", typeDocument);
      formData.append("expiresAt", company.expiresAt);
      formData.append("userId", company.id);

      // Realiza la solicitud con el FormData
      const res = await axios.post(endpoint, formData);

      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "Se ha actualizado el documento con éxito." || res.data.message,
      });
      reloadChildData();
      setViewList({ ...viewList, viewList: false });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de enviar el documento.",
      });
    }
  };

  const handleTypeDocument = (type) => {
    setTypeDocument(type);
  };

  const handleFileId = (id) => {
    setFileId(id);
  };

  const displayList = (viewOrNot) => {
    setViewList({ viewList: viewOrNot.viewList, tipeForm: viewOrNot.tipeForm });
  };

  const reloadChildData = () => {
    setReloadData(reloadData);
  };

  const resetForm = () => {
    setCompany(data);
    setFile(null);
    setFileUrl("");
    setTypeDocument("");
  };

  const handleClick = (e) => {
    e.preventDefault();
    handleUpload(e);
    resetForm();
  };

  const handlerClick = (e) => {
    e.preventDefault();
    editamb(e);
    resetForm();
  };

  const viewabmlist = (e, data) => {
    e.preventDefault();
    navigate("/detalle-company/", { state: data });
  };

  return (
    <div className={styles.informacionEconomica} id="ABM">
      <div className={styles.sectionTitle2}>
        <div className={styles.sectionTitle3}>
          <h2 className={styles.sectionTitleH2}>Abm de Documentos</h2>
          <IconAnimation />
        </div>
        <div className={styles.buttonsContainer}>
          {!company ? (
            <></>
          ) : (
            <div className="abmlistviewbutton">
              <button
                type="button"
                id="idbuttonabmviewlist"
                className="buttonviewñostabm"
                onClick={(e) => viewabmlist(e, data)}
              >
                <i className="fa fa-refresh"></i> Abm de Documentos
                <FaArrowRight className={styles.icon} />
              </button>
            </div>
          )}
        </div>
      </div>
      {!company ? (
        <NotReportViewData title="ABM de Documento" Icon={HiDocumentCheck} />
      ) : (
        <>
          {company.RelationshipWithMutualCompany.relation === "Proveedor" ? (
            <AMBListProveedorCompany
              data={data}
              displayList={displayList}
              setTypeDocument={handleTypeDocument}
              setFileId={handleFileId}
              reloadChildData={reloadChildData}
            />
          ) : (
            <AMBListFondistaCompany
              data={data}
              displayList={displayList}
              setTypeDocument={handleTypeDocument}
              setFileId={handleFileId}
              reloadChildData={reloadChildData}
            />
          )}
          {viewList.viewList === true ? (
            <div className="abmall">
              <div className="allbox">
                <div className="allabm">
                  <div className="box_data_desc">
                    <input
                      className="abminput"
                      type="number"
                      name="expiresAt"
                      placeholder="Fecha de vencimiento (Meses)"
                      value={company.expiresAt || ""}
                      onChange={handleInputChange}
                    />
                    <textarea
                      className="abmtextare"
                      placeholder="Descripcion"
                      name="description"
                      value={company.description || ""}
                      onChange={handleInputChange}
                    ></textarea>
                  </div>
                </div>
                <div className="fileallarchive">
                  <label className="custum-file-upload2" htmlFor="file">
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill=""
                        viewBox="0 0 24 24"
                      >
                        <g strokeWidth="0" id="SVGRepo_bgCarrier"></g>
                        <g
                          strokeLinejoin="round"
                          strokeLinecap="round"
                          id="SVGRepo_tracerCarrier"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            fill=""
                            d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                            clipRule="evenodd"
                            fillRule="evenodd"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <div className="text">
                      <span>Haga Click para subir un archivo</span>
                    </div>
                    <input
                      type="file"
                      id="file"
                      onChange={handleFileChange}
                      accept=".pdf, .jpg, .png"
                    ></input>
                  </label>
                </div>
              </div>
              {viewList.tipeForm === "Crear" ? (
                <div>
                  <button
                    className="button_ig_eg"
                    type="button"
                    onClick={(e) => handleClick(e)}
                  >
                    Guardar
                  </button>
                </div>
              ) : (
                <div>
                  <button
                    className="button_ig_eg"
                    type="button"
                    onClick={(e) => handlerClick(e)}
                  >
                    Editar
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div></div>
          )}
        </>
      )}
    </div>
  );
};

export default ABMOfDocumentsCompanies;
